import React from "react";
import { Link } from "react-router-dom";
import { Col, Container, Row } from "reactstrap";
import { servicesData } from "../data/services";

const ServicesCard = (props) => {
  return (
    <>
      <Col lg={4} md={6}>
        <Link
          to={`/services/${props.slug}`}
          className="service-card-link"
          aria-label={`View ${props.title} service details`}
        >
          <div
            className={
              props.isShadow
                ? "service-box text-center mt-4 box-shadow"
                : "service-box text-center mt-4"
            }
          >
            <img src={props.imgsrc} alt="" className="img-fluid" />
            <h5 className="fs-18 mt-4">{props.title}</h5>
            <div className="lighlight-border mt-3"></div>
            <p className="text-muted mt-3">{props.caption}</p>
            <span className="service-more-link">Learn more</span>
          </div>
        </Link>
      </Col>
      {/* <!--end col--> */}
    </>
  );
}

// Services data

const Services = () => {
  return (
    <>
      <section className="section" id="services">
        <Container>
          <Row className="justify-content-center">
            <Col lg={7}> 
              <div className="header-title text-center">
                {/* <p className="text-uppercase text-muted mb-2">
                  Services We Provide
                </p> */}
                <h3> Services We Provide</h3>
                <div className="title-border mt-3"></div>
                <p className="text-muted mt-3">
                At Citra, we help SAP customers design, build, and operate solutions on SAP Business Technology Platform and modern data platforms. Our services span data and analytics, integration, custom application development and Agentic AI, enabling organisations to integrate, extend, and modernise their SAP landscapes with confidence.
                </p>
              </div>
            </Col>
          </Row>

          <Row>
            {/* Services Component Start */}

            {servicesData.map((value) => (
              <ServicesCard
                key={value.slug}
                slug={value.slug}
                imgsrc={value.imgsrc}
                title={value.title}
                caption={value.caption}
                isShadow={value.isShadow}
              />
            ))}

            {/* Services Component End */}
          </Row>
        </Container>
      </section>
    </>
  );
}

export default Services;
